module.exports = __webpack_public_path__ + "img/VE.243693de.svg";